// Single source of truth for app version.
export const APP_VERSION = "0.98.1";

/**
 * Build-time git branch — injected by `vite.config.ts` via the `define:`
 * block (see `docs/runbooks/dev_sync_and_fix.md` §7 for the DevSync
 * branch-aware capture/export semantics).
 *
 * Resolution order at build time:
 *   1. `process.env.VERCEL_GIT_COMMIT_REF` (Vercel preview / prod builds)
 *   2. `git rev-parse --abbrev-ref HEAD` (local `vite dev`)
 *   3. The literal "unknown"
 */
declare const __GIT_BRANCH__: string;
export const APP_GIT_BRANCH: string =
  typeof __GIT_BRANCH__ === "string" && __GIT_BRANCH__ ? __GIT_BRANCH__ : "unknown";

/** Default branch name used for back-compat filtering of untagged rows. */
export const DEFAULT_GIT_BRANCH = "main";

export function isDefaultBranch(branch: string | null | undefined): boolean {
  return (branch ?? "").trim() === DEFAULT_GIT_BRANCH;
}
